import { AuthorBylineSimple } from "~/components/AuthorBylineSimple";
import { FormattedDate } from "~/components/FormattedDate";

type AuthorBylineItem = {
  authorName: string;
  authorTitle: string;
  href: string;
  headshotImageUrl: string | null;
};

export type ArticleBylineProps = {
  authorsList: AuthorBylineItem[];
  /** The date to be formatted below the author name */
  publishDate: string | null;
};

export const ArticleByline = ({
  authorsList,
  publishDate,
}: ArticleBylineProps) => (
  <div className="flex flex-col gap-xs">
    {authorsList.length ? (
      <div className="flex items-center gap-[0.75rem]">
        <AuthorBylineSimple authors={authorsList} linkAppearance="bold" />
      </div>
    ) : null}

    {publishDate ? (
      <FormattedDate
        className="text-gray-700"
        date={new Date(publishDate)}
        includeTZ
      />
    ) : null}
  </div>
);
